import React from 'react';
import { getDataSource } from '../utils/dataSources';

/**
 * A reusable component for displaying data source badges
 * 
 * @param {Object} props - Component props
 * @param {string} props.sourceId - The ID of the data source
 * @param {string} props.size - Size of the badge ('sm', 'md', 'lg')
 * @param {boolean} props.showIcon - Whether to show the icon
 * @param {boolean} props.fullName - Whether to show the full name instead of short name
 * @param {string} props.className - Additional classes to apply
 */
const DataSourceBadge = ({ 
  sourceId, 
  size = 'md', 
  showIcon = true,
  fullName = false,
  className = ''
}) => {
  if (!sourceId) return null;
  
  // Get data source configuration
  const dataSource = getDataSource(sourceId.toUpperCase());
  
  // Size classes
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };
  
  return (
    <span 
      className={`inline-flex items-center rounded-md font-medium ${dataSource.badgeColor} ${sizeClasses[size]} ${className}`}
      title={dataSource.name}
    >
      {showIcon && <i className={`${dataSource.icon} ${size === 'sm' ? 'text-xs' : 'text-sm'} ${fullName ? 'mr-1.5' : 'mr-1'}`}></i>}
      {fullName ? dataSource.name : dataSource.shortName}
    </span>
  );
};

export default DataSourceBadge; 